import qs from 'qs'
import http from './http'
import { CashoutResponse, GetCashoutParams } from './types/cash-outs'

export const getCashouts = (orgId: number, params?: GetCashoutParams) =>
  http.get<CashoutResponse>(
    `/payout/organizations/${orgId}/cash_outs?${qs.stringify(params)}`
  )
